import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import MainLayout from "../../components/layouts/mainLayout";
import IndividualRegistrationForm from "../../components/molecules/form/individualRegistrationForm";
import { AppContext } from "../../context/AppContext";

const IndividualDelegation = () => {
  const res = useContext(AppContext);
  const navigate = useNavigate();
  const user = res?.appLoadingStates?.user;

  useEffect(() => {
    if (!user && res.appLoadingStates?.userStateFetched) navigate("/");
  }, [user]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          width: "100vw",
          position: "relative",
          maxWidth: "1920px",
        }}
      >
        <MainLayout componentFlag="dashboard">
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ minHeight: "1000px" }}>
              <IndividualRegistrationForm isTeams={false} />
            </div>
          </div>
        </MainLayout>
      </div>
    </div>
  );
};

export default IndividualDelegation;
